<template>

    <!--投诉榜-->

    <div :class="{'wrap':true, 'bgcolor':!active}">

        <!--市场 监督模块-->
        <div class="head" v-if="active">
            <span class="head-text" v-text="title"></span>
            <span class="more" v-show="more" @click="goNewsList()">MORE></span>
        </div>
        <!--active为false时蓝色横线在title上方-->
        <div class="active" v-else>
            <span class="head-text" v-text="title" style="padding-left:10px;"></span>
            <span class="more" v-if="more" @click="toShandongNews">MORE></span>
        </div>
        <div class="news-list">

            <div :key="index" v-for="(item, index) in info">
                <router-link v-if="item.type===2"
                             class="first-news"
                             :to="{ name: 'complainInfo', query: { id: item.id,cate:item.cate,cateTitle:title}}"
                             tag="div">
                    <img  style="margin-right:8px; object-fit: contain;" class="info-img" v-if="item.logo" :src="item.logo" alt="">
                    <span style="width:333px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;display: inline-block"
                          v-text="item.title"></span>
                </router-link>

                <router-link v-if="item.type===1"
                             class="first-news" :to="{ name: 'article', query: { id: item.id,cateTitle:title}}"
                             tag="div">
                    <img  style="margin-right:8px;" class="info-img" v-if="item.logo" :src="item.logo" alt="">
                    <span style="width:100%;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;display: inline-block"
                          v-text="item.title"></span>
                </router-link>
            </div>

        </div>
    </div>
</template>

<script>
  export default {
    name: "NewsModule",
    props: [
      'info', //新闻数据{对象}
      'title',//新闻类别'字符串'
      'active',
      'more',
      'type',
    ],
    data() {
      return {}
    },
    methods: {
      toShandongNews() {
        this.$router.push({name: 'ArticleList',})
      },
      goNewsList() {
        this.$router.push({name: 'ArticleList', query: {page: 1, type: this.type, cateTitle: this.title}})
      }
    }

  }
</script>

<style scoped lang="less">
    .wrap {
        width: 350px;
    }

    .head {
        border-bottom: 2px solid #4a90e2;
        height: 30px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
    }

    .active {
        height: 30px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        padding-top: 10px;
    }

    .head-text {
        height: 21px;
        font-size: 18px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        color: rgba(41, 75, 127, 1);
        line-height: 21px;
    }

    .more {
        height: 21px;
        font-size: 13px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        color: rgba(41, 75, 127, 1);
        line-height: 21px;

    }

    .more {
        color: rgba(153, 153, 153, 1);
        cursor: pointer;
    }

    .first-news {
        display: flex;
        margin-bottom: 15px;
        cursor: pointer;

        img {
            display: none;
        }

        span {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }
    }

    .first-news:nth-child(1) > img {
        display: block;
        width: 150px;
        height: 100px;
    }

    .first-news > a {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
    }

    .news {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: rgba(51, 51, 51, 1);
        line-height: 19px;
        margin: 8px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .news-list {
        height: 285px;
        padding: 0 10px;
        overflow: hidden;
        >div{
            .info-img{
                display:none;
            }
        }
        >div:nth-of-type(1){
            .info-img{
                display: block;
            }
        }
    }

    .bgcolor {
        background: #f3f3f3;
        padding: 5px;
        border-top: 2px solid #4a90e2
    }
</style>
